import { render, staticRenderFns } from "./CustomerSentSmsDatatable.vue?vue&type=template&id=7237dfc3"
import script from "./CustomerSentSmsDatatable.vue?vue&type=script&lang=js"
export * from "./CustomerSentSmsDatatable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports